﻿<script lang="ts">
	import { fade, fly } from "svelte/transition";
	import { cubicOut } from "svelte/easing";
	import SvgIcon from "./svg-icon.svelte";
	import type { FormSubmissionSource } from "./models";

	export let source: string;
	export let component: any;
	export let closed: () => void;
</script>

<svelte:window on:keydown={(e) => e.key === "Escape" && closed()} />
<div class="modal is-active">
	<div class="modal-background" on:click={() => closed()} transition:fade={{ duration: 300, easing: cubicOut }}></div>
	<div class="modal-content" transition:fly={{ duration: 400, y: 100, easing: cubicOut }}>
		<svelte:component this={component} {source} />
	</div>
	<button class="modal-close is-large button is-primary" aria-label="close" on:click={() => closed()} transition:fade={{ duration: 300, easing: cubicOut }}>
		<SvgIcon name="close" />
	</button>
</div>
